import { makeStyles } from "@mui/styles";

export const useNewStyle = makeStyles({
  container: {
    flex: 1,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px -12px 6px #00000029",
    borderRadius: "42px 0px 0px 0px",
    width: "100%",
    padding: "42px 0 0 0",
  },
  rootTopBox: {
    display: "flex",
    flexDirection: "row",
    padding: "0 0 0 40px",
    alignItems: "center",
  },
  boxSelect: {
    display: "flex",
    flexDirection: "row",
    margin: "0 30px 0 0",
  },
  rootSelect: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    width: "198px",
    height: "47px",
    marginRight: "28px",
  },
  inputGalenique: {
    width: "269px",
    border: "1px solid #FFE6E6",
    background: "#00000029",
    borderRadius: "6px",
  },
  boxCard: {
    display: "flex",
    padding: "40px",
  },
  rootCard: {
    margin: "0 24px 0 0",
  },
  inputDrag: {
    width: "506px",
    height: "258px",

    borderRadius: "16px",
    boxShadow: "10px 10px 5px 0px rgba(0,0,0,0.33) inset",
    MozBoxShadow: "10px 10px 5px 0px rgba(0,0,0,0.33) inset",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  previewList: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    width: "488px",
    justifyContent: "center",
  },
  img: {
    width: "488px",
    height: "245px",
    // `contain` et non `cover` : une ordonnance est un document, la rogner
    // peut faire disparaître une ligne de posologie hors du cadre.
    objectFit: "contain",
    background: "#FFFFFF",
    borderRadius: "16px",
  },
  imgMultiple: {
    flex: 1,
    minWidth: 0,
    height: "245px",
    objectFit: "contain",
    background: "#FFFFFF",
    borderRadius: "16px",
  },
  /** Annonce qu'un second document est possible, avant même de déposer. */
  instruction: {
    margin: "-12px 0 16px 0",
    fontSize: "14px",
    color: "#00000099",
  },
  /**
   * Emplacement libre : cadre en pointillés, l'idiome habituel pour « il reste
   * de la place ». Non cliquable, c'est la zone entière qui reçoit le dépôt.
   */
  emptySlot: {
    flex: 1,
    minWidth: 0,
    height: "245px",
    borderRadius: "16px",
    border: "2px dashed rgba(255, 255, 255, 0.7)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    color: "#FFFFFF",
    textAlign: "center",
    padding: "0 8px",
  },
  boxSubtTileImg: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  boxSavegardPlanner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
